import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H1, H2, H3, H4, H5 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph1, Paragraph2, Paragraph3, Paragraph4, Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';

const TextWrapper = styled.div<{ $lastIndent?: boolean }>`
    display: block;
    
    ${H1} {
        margin-bottom: 16px;
        
        @media (min-width: ${wideBreakpoints.mobile}) {
            margin-bottom: 24px;
        }
    }
    
    ${H2} {
        margin-bottom: 8px;
        
        @media (min-width: ${wideBreakpoints.mobile}) {
            margin-bottom: 16px;
        }
    }
    
    ${H3}, ${H4}, ${H5} {
        margin-bottom: 8px;
    }
    
    ${Paragraph1}, ${Paragraph2}, ${Paragraph3}, ${Paragraph4}, ${Paragraph5} {
        margin-bottom: 16px;

        ${({ $lastIndent = true }) => $lastIndent
            ? ''
            : css`
                &:last-child {
                    margin-bottom: 0px;
                }
            `}
    }
`;

export default TextWrapper;
